import type {
  CaptureSignatureDto,
  ConfirmContactDto,
  ProcessSessionResponseDto,
} from '@carvia/ros-client-types';
import type { GetPresignedUploadUrlResponse } from '@/api/interfaces/get-presigned-upload-url-response.interface';
import { httpClient } from './http-client';
import axios from 'axios';

class CounterProcessSessionService {
  private readonly httpClient = httpClient;
  async getProcessSession(counterId: string) {
    const res = await this.httpClient.get<ProcessSessionResponseDto | null>(
      `/counters/${counterId}/process-session`,
    );
    return res.data;
  }

  async confirmContact(counterId: string, dto: ConfirmContactDto) {
    const res = await this.httpClient.patch<ProcessSessionResponseDto>(
      `/counters/${counterId}/process-session/contact`,
      dto,
    );
    return res.data;
  }

  async unconfirmContact(counterId: string) {
    const res = await this.httpClient.delete<ProcessSessionResponseDto>(
      `/counters/${counterId}/process-session/contact`,
    );
    return res.data;
  }

  async captureSignature(counterId: string, dto: CaptureSignatureDto) {
    const res = await this.httpClient.post<ProcessSessionResponseDto>(
      `/counters/${counterId}/process-session/signature`,
      dto,
    );
    return res.data;
  }

  async uploadSignature(counterId: string, file: Blob) {
    const uploadUrl = await this.httpClient.get<GetPresignedUploadUrlResponse>(
      `/counters/${counterId}/process-session/signature/upload-url`,
    );
    const { url, fileKey } = uploadUrl.data;
    await axios.put(url, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return { fileKey };
  }

  async getContractHtml(counterId: string) {
    const res = await this.httpClient.get<string>(
      `/counters/${counterId}/process-session/contract`,
    );
    return res.data;
  }
}

export const counterProcessSessionService = new CounterProcessSessionService();
